import { Form, Spin, Button } from "antd";
import { useContext, useState } from "react";
import { ForgotPasswordContext } from "../../../context/forgotPasswordContext";
import { FORGOT_PASSWORD_STEPS } from "../../../data/constants";
import useStep from "../../../hooks/useStep";
import AuthContainerItem from "../../authContainer/authContainerItem";
import ErrorMessage from "../../common/errorMessage/errorMessage";

import "./forgotPasswordFormStep.css";

const ForgotPasswordFormStep = ({
    FormStepHeader,
    children,
    formStepCallback,
}) => {
    const { currentStep, recoveryByCuit, changeStep, setDataResponseStep: setDataToNextStep } = useContext(ForgotPasswordContext);

    const { loading, error, onFinishStep } = useStep(
        formStepCallback,
        changeStep,
		setDataToNextStep,
		recoveryByCuit
    );

    const onFinish = (values) => {
        onFinishStep(values);
    };

    return (
        <>
            <AuthContainerItem className='forgotPassword-header'>
                {FormStepHeader}
            </AuthContainerItem>

            <AuthContainerItem>
                <Spin spinning={loading}>
                    <Form name='forgotPasswordForm' onFinish={onFinish}>
                        {children}
                    </Form>
                </Spin>
            </AuthContainerItem>

            {error && (
                <div className='forgotPassword-error '>
                    <ErrorMessage
                        type='error'
                        errorName={`${currentStep}_${error}`}
                    />
                </div>
            )}
        </>
    );
};

export default ForgotPasswordFormStep;
